export const SUGGESTIONS_OVER_CAPACITY_HOURS_BUFFER = 0.0;
export const SUGGESTIONS_OVER_CAPACITY_OCCURENCE_TOLERANCE = 0;
export const SUGGESTIONS_MIN_HOURS = 2;
